import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUI from '@mui/material';

const Theme = Common.Theme;

export const InputGroup = styled(Common.InputGroup)``;

export const TextField = styled(Common.TextField)``;

export const ButtonGroup = styled(Common.ButtonGroup)``;

export const Button = styled(Common.Button)``;

export const FlexRow = styled(Common.FlexRow)`
	gap: 1rem;
`;

export const Select = styled(Common.Select)``;

export const MenuItem = styled(Common.MenuItem)``;

export const Dialog = styled(Common.Dialog)``;

export const DialogActions = styled(Common.DialogActions)``;

export const DialogTitle = styled(Common.DialogTitle)``;

export const DialogContent = styled(Common.DialogContent)`
	margin-top: -16px !important;
	padding: 1rem !important;
`;

export const CircularButton = styled(Common.CircularButton)``;

export const LocalizationProvider = styled(Common.LocalizationProvider)``;

export const DatePicker = styled(Common.DatePicker)``;

export const HighlightBox = styled.div`
	margin: 0.5rem 0;
	padding: 0.25rem 1rem 0.75rem;
	background-color: #eefaf4;
	border-left: 3px solid ${Theme.primary};
	border-radius: 4px;
`;

export const HelperText = styled.div`
	font-size: 12px;
	line-height: 16px;
	color: #4a4d4c;
	margin-top: -0.25rem;
	margin-bottom: 0.5rem;
`;

export const SectionHint = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: #000000;
	margin: 0.5rem 0;
`;

export const BoldLabel = styled.span`
	font-weight: 600;
	margin-left: -10px;
`;
